import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./Header.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import UserMenu from "./UserMenu";
import StudentDropdown from "./StudentDropdown";
import { studentName } from "../../helpers";

class Header extends Component {
  state = {
    isHiddenUser: true,
    isHiddenMenu: true
  };

  openDropdown = menuindex => {
    const newState = { ...this.state };
    newState[`isHidden${menuindex}`] = !this.state[`isHidden${menuindex}`];
    this.setState(newState);
  };
  render() {
    return (
      <header className="main-nav">
        <div className="nav-wrapper">
          <div className="nav-title" onClick={() => this.openDropdown("Menu")}>
            <FontAwesomeIcon icon={faDesktop} />
            <h5>{this.props.activeTitle}</h5>
            <FontAwesomeIcon icon={faCaretDown} />
            {!this.state.isHiddenMenu && <StudentDropdown />}
          </div>
          <div
            onClick={() => this.openDropdown("User")}
            className="nav-dropdown"
          >
            <h5>{studentName}</h5> <FontAwesomeIcon icon={faCaretDown} />
            {!this.state.isHiddenUser && <UserMenu />}
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
